import React from 'react';
import { connect } from 'react-redux';
import { HttpStateLine } from 'state-line';

import CircularProgress from 'xgimi-ui/mui/material/CircularProgress';
import Container from 'xgimi-ui/Container';
import { formatUrlParams, getUrlParams } from 'xgimi-utils/url';

import StoreComponent, { mapStateToProps } from '../../../../appComponents/Store';
import ScrollTop from '../../../../components/ScrollTop';
import Filter from './Filter';
import ListItem from './ListItem';

import s from './.module.scss';
import Api from '../../../../api';

interface Props {

}

interface State {
  // 是否在获取登录信息
  isLogin: boolean;
  // 是否正在获取
  isGettingData: boolean;
  currentPage: number;
  // 反馈列表
  list: Record<any, any>[];
  // 当前数据列表
  currentList: Record<any, any>[];
  // 过滤条件
  filterData: Record<any, any>;
  // 当前用户
  ownerUser: string | undefined;
  scrollTop: number;
}

/**
 * 企业微信端意见反馈列表
 */
class Component extends StoreComponent<Props, State> {
  state: State = {
    isLogin: true,
    isGettingData: false,
    currentPage: 1,
    list: [],
    currentList: [],
    filterData: {
      replyStatus: -1,
      feedbackTypeCode: '-1',
      processStatus: -1,
      ownerUser: undefined,
    },
    ownerUser: undefined,
    scrollTop: 0,
  };

  // 当前滚动条的位置
  private currentScrollTop = 0;

  constructor(props: Props) {
    super(props, { title: '意见反馈列表' });
  }

  componentDidMount() {
    this.getLoginInfo();
  }

  /**
   * 获取登录信息
   */
  private getLoginInfo = (): void => {
    new HttpStateLine(new Api.crmFeedback.GetLoginInfo({ code: getUrlParams().code }), {
      onSuccess: (httpStateLine) => {
        // 如果有缓存则优先加载缓存中的数据
        const crmItem = window.localStorage.getItem('crm_list');
        if (crmItem) {
          const state = JSON.parse(crmItem);
          const list = state.list;
          // 取出缓存中的更新数据
          const detail = window.localStorage.getItem('crm_detail');
          if (detail) {
            list[state.currentIndex] = { ...list[state.currentIndex], ...JSON.parse(detail) };
          }
          this.setState({ ...state, list });
          // 加载后清空缓存
          window.localStorage.setItem('crm_list', '');
          window.localStorage.setItem('crm_detail', '');
        } else {
          // 如果url中带有搜索条件则使用url中的条件
          const params = getUrlParams();
          const keys = Object.keys(this.state.filterData);
          keys.forEach((key) => {
            if (params[key] === undefined || params[key] === '') {
              delete params[key];
            }
          });
          const filterData = { ...this.state.filterData, ownerUser: httpStateLine.result?.data?.userName, ...params };
          // 登录成功了才执行后续的业务
          this.setState({ isLogin: false, filterData, ownerUser: httpStateLine.result?.data?.userName }, this.getFeedbackList);
        }
      },
    }).run();
  };

  /**
   * 获取反馈列表
   */
  private getFeedbackList = async (): Promise<void> => {
    this.setState({ isGettingData: true });
    // 把选项为全部的条件过滤掉
    const params: Record<string, any> = {};
    const keys = Object.keys(this.state.filterData);
    keys.forEach((key) => {
      if (String(this.state.filterData[key]) !== '-1') {
        params[key] = this.state.filterData[key];
      }
    });
    const list: Record<string, any>[] = [...this.state.list];
    const httpStateLine = await new HttpStateLine(new Api.crmFeedback.GetList({
      currentPage: this.state.currentPage,
      pageSize: 10,
      ...params,
    })).run().catch(() => null);
    httpStateLine?.result?.data?.data?.forEach((item: Record<string, any>) => {
      list.push(item);
    });
    this.setState({ list, currentList: httpStateLine?.result?.data?.data || [], isGettingData: false });
  };

  render(): React.ReactNode {
    return (
      <Container className={s.container} isMobile={true}>
        {this.state.isLogin ? <div className={s.progress}><CircularProgress size={20} /></div> : (
          <ScrollTop
            className={s.scrollContainer}
            scrollTop={this.state.scrollTop}
            onScroll={(scrollTop) => {
              this.currentScrollTop = scrollTop;
            }}
            onScrollBottom={() => {
              // 没有正在进行的请求
              if (!this.state.isGettingData) {
                this.setState((preState) => ({
                  currentPage: preState.currentPage + 1,
                }), this.getFeedbackList);
              }
            }}
          >
            <Filter
              ownerUser={this.state.ownerUser}
              filterData={this.state.filterData}
              onFilter={(data) => {
                this.setState({ filterData: data });
                this.setState({ list: [], currentList: [], currentPage: 1 }, this.getFeedbackList);
              }}
            />
            <div className={s.list}>
              {this.state.list.map((item, index) => (
                <ListItem
                  data={item}
                  key={index}
                  onDetail={(feedbackNo) => {
                    const params = { ...this.state.filterData };
                    // 如果链接中有code的话带上code
                    const code = getUrlParams().code;
                    if (code) {
                      params.code = code;
                    }

                    window.localStorage.setItem('crm_list', JSON.stringify({ ...this.state, scrollTop: this.currentScrollTop, currentIndex: index }));
                    this.history.push(`/crm/feedback/detail/${feedbackNo}?${formatUrlParams(params)}`);
                  }}
                />
              ))}
            </div>
            {/* 加载状态 */}
            {this.state.isGettingData && (<div className={s.progress}><CircularProgress size={20} /></div>)}
            {/* 提示语 */}
            {!this.state.isGettingData && <div className={s.tip}>没有更多了</div>}
          </ScrollTop>
        )}
      </Container>
    );
  }
}

export default connect(mapStateToProps)(Component);
